import React, { useState } from "react";
import {
  Typography,
  Container,
  Box,
  InputLabel,
  Button,
  Grid,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import { registerManufacturer } from "./api/manufacturerApi";

const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
          fontWeight: "bold",
          marginBottom: "4px",
          display: "block",
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
          padding: "4px 8px",
        },
      },
    },
  },
});

const StyledFormBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff",
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
}));

const RequiredStar = styled("span")(({ theme }) => ({
  color: theme.palette.error.main,
}));

const ManufacturerRegistration = () => {
  const [addressType, setaddressType] = useState("");
  const [name, setname] = useState("");
  const [gstin, setGstin] = useState("");
  const [pan, setpan] = useState("");
  const [cin, setcin] = useState("");
  const [contact, setcontact] = useState("");
  const [email, setemail] = useState("");
  const [addressLane1, setaddressLane1] = useState("");
  const [addressLane2, setaddressLane2] = useState("");
  const [city, setCity] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [state, setState] = useState("");
  const history = useHistory();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "addressType":
        setaddressType(value);
        break;
      case "name":
        setname(value);
        break;
      case "gstin":
        setGstin(value);
        break;
      case "pan":
        setpan(value);
        break;
      case "cin":
        setcin(value);
        break;
      case "contact":
        setcontact(value);
        break;
      case "email":
        setemail(value);
        break;
      case "addressLane1":
        setaddressLane1(value);
        break;
      case "addressLane2":
        setaddressLane2(value);
        break;
      case "city":
        setCity(value);
        break;
      case "pinCode":
        setPinCode(value);
        break;
      case "state":
        setState(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async () => {
    const payload = {
      name,
      contact,
      email,
      gstin,
      cin,
      pan,
      addressType,
      addressLane1,
      addressLane2,
      state,
      city,
      pincode: pinCode,
    };

    try {
      await registerManufacturer(payload);
      alert("Manufacturer registered successfully!");
      history.push("/manufacturer-overview");
    } catch (error) {
      console.error("API Error:", error);
      alert("Failed to register manufacturer: " + error.message);
    }
  };

  const handleCancel = () => {
    console.log("Registration cancelled");
  };

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="lg">
        <Box mt={3} mb={2}>
          <Typography variant="h5" component="h1" gutterBottom>
            Manufacturer Registration
          </Typography>
          <StyledFormBox>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4}>
                <InputLabel htmlFor="name">
                  Name <RequiredStar>*</RequiredStar>
                </InputLabel>
                <TextField
                  required
                  fullWidth
                  id="name"
                  name="name"
                  variant="outlined"
                  value={name}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InputLabel htmlFor="gstin">GSTIN</InputLabel>
                <TextField
                  fullWidth
                  id="gstin"
                  name="gstin"
                  variant="outlined"
                  value={gstin}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InputLabel htmlFor="pan">
                  PAN Number <RequiredStar>*</RequiredStar>
                </InputLabel>
                <TextField
                  required
                  fullWidth
                  id="pan"
                  name="pan"
                  variant="outlined"
                  value={pan}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InputLabel htmlFor="cin">
                  CIN Number <RequiredStar>*</RequiredStar>
                </InputLabel>
                <TextField
                  required
                  fullWidth
                  id="cin"
                  name="cin"
                  variant="outlined"
                  value={cin}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InputLabel htmlFor="contact">
                  Contact Number <RequiredStar>*</RequiredStar>
                </InputLabel>
                <TextField
                  required
                  fullWidth
                  id="contact"
                  name="contact"
                  variant="outlined"
                  value={contact}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InputLabel htmlFor="email">Email</InputLabel>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  variant="outlined"
                  value={email}
                  onChange={handleInputChange}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <InputLabel htmlFor="city">
                  City <RequiredStar>*</RequiredStar>
                </InputLabel>
                <TextField
                  required
                  fullWidth
                  id="city"
                  name="city"
                  variant="outlined"
                  value={city}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InputLabel htmlFor="pinCode">
                  Pin Code <RequiredStar>*</RequiredStar>
                </InputLabel>
                <TextField
                  required
                  fullWidth
                  id="pinCode"
                  name="pinCode"
                  variant="outlined"
                  value={pinCode}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InputLabel htmlFor="addressType">
                  Address Type <RequiredStar>*</RequiredStar>
                </InputLabel>
                <FormControl fullWidth variant="outlined" required>
                  <Select
                    id="addressType"
                    name="addressType"
                    value={addressType}
                    onChange={handleInputChange}
                    label={
                      <>
                        Address Type <RequiredStar>*</RequiredStar>
                      </>
                    }
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    <MenuItem value="headOffice">Head Office</MenuItem>
                    <MenuItem value="localOffice">Local Office</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <InputLabel htmlFor="state">
                  State <RequiredStar>*</RequiredStar>
                </InputLabel>
                <TextField
                  required
                  fullWidth
                  id="state"
                  name="state"
                  variant="outlined"
                  value={state}
                  onChange={handleInputChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputLabel htmlFor="addressLane1">
                  Address Lane 1 <RequiredStar>*</RequiredStar>
                </InputLabel>
                <TextField
                  required
                  fullWidth
                  id="addressLane1"
                  name="addressLane1"
                  variant="outlined"
                  value={addressLane1}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputLabel htmlFor="addressLane2">Address Lane 2</InputLabel>
                <TextField
                  fullWidth
                  id="addressLane2"
                  name="addressLane2"
                  variant="outlined"
                  value={addressLane2}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1.5 }}>
              <Button onClick={handleCancel}>Cancel</Button>
              <StyledButton
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                type="submit"
              >
                Register
              </StyledButton>
            </Box>
          </StyledFormBox>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default ManufacturerRegistration;
